export const TOGGLE_MODAL_MQ_CHANGE_DECISION =
  "TOGGLE_MODAL_MQ_CHANGE_DECISION";

export const MODAL_MQ_CHANGE_DECISION_OPEN = "MODAL_MQ_CHANGE_DECISION_OPEN";
export const CHANGE_DECISION_DETAILS = "CHANGE_DECISION_DETAILS";

export const SET_CHANGE_DECISION_DETAILS = "SET_CHANGE_DECISION_DETAILS";
export const GET_CHANGE_DECISION_DETAILS = "GET_CHANGE_DECISION_DETAILS";



// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/types/changeDecisionModalReducerTypes.js